/* eslint-disable max-len */
/* eslint-disable no-underscore-dangle */
/* eslint-disable react/forbid-prop-types */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import QueryString from 'query-string';
import { Card, CardBody } from 'reactstrap';
import PropTypes from 'prop-types';
import { changeTitleAction } from '../../../redux/actions/topbarActions';
import {
  createEmailTemplate, getAllEmailTemplates, removeEmailTemplateById, updateEmailTemplate,
} from '../../../redux/actions/emailTemplateActions';
import DeleteModal from '../../../shared/components/Modal/Modal';
import Notification from '../../../shared/components/Notifications/BasicNotification';
import TemplateModal from './templates-modal';
import TemplatesHeader from './templates-header';
import TemplatesList from './templates-list';

class TemplatesContent extends Component {
  constructor() {
    super();
    this.state = {
      id: null,
      isOpenDeleteModal: false,
      isOpenTemplateModal: false,
      modalTitle: '',
      templateTitle: '',
    };
  }

  componentDidMount() {
    this.props.setTitle('Plantillas');
  }

  deleteTemplate = accept => () => {
    if (accept) {
      this.props.removeEmailTemplateById(this.state.id, () => {
        this.setState({ isOpenDeleteModal: false, id: null });
        this.props.getAllEmailTemplates();
      });
    } else {
      this.setState({ isOpenDeleteModal: false, id: null });
    }
  }

  submitTemplate = () => {
    let body;
    if (this.templateRef) {
      body = this.templateRef.getTextHtml();
    }
    if (!body) {
      Notification.show({
        color: 'danger',
        title: 'Atención',
        message: 'Debe ingresar un mensaje para guardar plantilla.',
      });
      return;
    }
    const title = this.state.templateTitle;
    if (title.length < 1) {
      Notification.show({
        color: 'danger',
        title: 'Atención',
        message: 'Debe ingresar un titulo para guardar la plantilla.',
      });
      return;
    }
    const { id } = this.state;
    const template = { title, body };
    this.sendTemplate(id, template);
  }

  sendTemplate = (id, template) => {
    if (id) {
      this.props.updateEmailTemplate(id, template, () => {
        this.resetTemplateModal();
        this.updateData();
      });
    } else {
      this.props.createEmailTemplate(template, () => {
        this.resetTemplateModal();
        this.updateData();
      });
    }
  }

  resetTemplateModal = () => {
    this.setState({
      isOpenTemplateModal: false,
      id: null,
      templateTitle: '',
      modalTitle: '',
    });
  }

  updateData = () => {
    let { page = 1, limit = 10 } = QueryString.parse(this.props.location.search);
    const query = {};
    if (page && !Number.isNaN(page)) {
      page = parseInt(page, 10) - 1;
      Object.assign(query, { page: page + 1 });
    }
    if (limit && !Number.isNaN(limit)) {
      limit = parseInt(limit, 10);
      Object.assign(query, { limit });
    }
    this.props.getAllEmailTemplates({ ...query });
  }

  clickActions = (action, template) => {
    switch (action) {
      case 'create':
        return this.setState({
          modalTitle: 'Nueva Plantilla',
          isOpenTemplateModal: true,
        });
      case 'edit':
        this.setState({
          modalTitle: 'Editar Plantilla',
          id: template._id,
          templateTitle: template.title,
          isOpenTemplateModal: true,
        });
        return setTimeout(() => {
          this.templateRef.setTextHtml(template.body);
        }, 500);
      case 'delete':
        return this.setState({ isOpenDeleteModal: true, id: template._id });
      default:
        return null;
    }
  }

  onChangeTitle = (e) => {
    this.setState({ templateTitle: e.target.value });
  };

  setTemplateRef = (element) => {
    this.templateRef = element;
  };

  render() {
    const { loading } = this.props;
    return (
      <div className="templates container">
        <Card>
          <CardBody>
            <TemplateModal
              ref={this.setTemplateRef}
              loading={loading}
              toggleModalNewMessage={this.resetTemplateModal}
              onChangeTitle={this.onChangeTitle}
              isOpenModalTemplate={this.state.isOpenTemplateModal}
              onSubmit={this.submitTemplate}
              title={this.state.modalTitle}
              template={this.state.templateTitle}
            />
            <DeleteModal
              color="warning"
              title="¡Atención!"
              message="¿Está seguro que desea eliminar la plantilla?"
              toggle={this.deleteTemplate}
              isOpen={this.state.isOpenDeleteModal}
            />
            <TemplatesHeader createTemplate={this.clickActions} />
            <TemplatesList location={this.props.location} history={this.props.history} action={this.clickActions} />
          </CardBody>
        </Card>
      </div>
    );
  }
}

TemplatesContent.propTypes = {
  createEmailTemplate: PropTypes.func.isRequired,
  getAllEmailTemplates: PropTypes.func.isRequired,
  history: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
  removeEmailTemplateById: PropTypes.func.isRequired,
  setTitle: PropTypes.func.isRequired,
  updateEmailTemplate: PropTypes.func.isRequired,
  loading: PropTypes.bool,
};

TemplatesContent.defaultProps = {
  loading: false,
};

const mapDispatchToProps = {
  createEmailTemplate,
  getAllEmailTemplates,
  removeEmailTemplateById,
  setTitle: changeTitleAction,
  updateEmailTemplate,
};

export default connect(null, mapDispatchToProps, null, { forwardRef: true })(TemplatesContent);
